/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A place for VDK Web CTV UI components and utilities (@accedo/vdkweb-tv-ui) 7.1.2
* 
*******************************************************************************/
import { withLayout } from '@accedo/vdkweb-navigation';
import React from 'react';
import FocusDiv from '../FocusDiv/FocusDiv';
var X = function X(props) {
  return /*#__PURE__*/React.createElement(FocusDiv, props);
};
export default withLayout(X);